/*
 * Copyright (c) 2021. World Wide Generation Ltd
 */

import { Button } from 'reactstrap';
import React from 'react';
import { TokenParams } from '@okta/okta-auth-js';
import { IdentityProvider } from '../../types/sso';
import { useOktaAuth } from '@okta/okta-react';
import './IdpLoginContainer.scss';

interface IdpButton {
  idpConfig: IdentityProvider,
  onClick: (idp: IdentityProvider) => void
}

const IdpLoginButton = ({ idpConfig, onClick }: IdpButton) => {
  const { code, name, logo } = idpConfig;

  return (
    <div className={logo ? 'logo-idp' : 'logo-none'}>
      <Button outline color={'primary'} className={'w-100 mb-3'} onClick={() => onClick(idpConfig)}>
        {logo && <img className={'btn-icon'} width={'24px'} src={logo} alt={code} />}
        <span className={'btn-text text-truncate'}>Login with {name}</span>
      </Button>
    </div>
  );
};

interface IdpLoginContainerProps extends TokenParams {
  idps: IdentityProvider[],
  redirectPath?: string
}

export function IdpLoginContainer({ idps, redirectPath }: IdpLoginContainerProps) {

  const { oktaAuth } = useOktaAuth();

  const onClick = (idpConfig: IdentityProvider) => {
    oktaAuth.signInWithRedirect({
      originalUri: redirectPath,
      idp: idpConfig.idp,
    }).catch(console.error)
  }

  return <div className='idp-container'>
    {idps.map(idp => <IdpLoginButton onClick={onClick} key={idp.code} idpConfig={idp} />)}
  </div>
}
